import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Fornecedor } from 'src/app/models/fornecedor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { TagGi } from 'src/app/models/tag-gi';
import { TagGiService } from 'src/app/services/tag-gi.service';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { IbgeService } from 'src/app/services/ibge.service';
import { Ibge } from 'src/app/models/ibge';
import { PaginatorService } from 'src/app/services/paginator.service';
import { MatPaginator, PageEvent } from '@angular/material';
import { Filtro } from 'src/app/models/filtro';
import Quill from 'quill';
import { QuillCounterModule } from 'src/app/quill-editor/quill-counter-module';

Quill.register('modules/counter', QuillCounterModule);

@Component({
  selector: 'app-cadastrar-fornecedor',
  templateUrl: './cadastrar-fornecedor.component.html',
  styleUrls: ['./cadastrar-fornecedor.component.scss'],
})
export class CadastrarFornecedorComponent implements OnInit, AfterViewInit {
  // variáveis
  idFornecedor: any;
  fornecedor = new Fornecedor();
  editando = false;
  carregando = true;
  tags: TagGi[] = [];
  Number = Number;
  titulo = '';
  pCentroDistribuicao = false;
  multiFornecedores = false;
  editavel = true;
  premissas: PremissasSistema = new PremissasSistema();

  estados = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadesFiltro: Ibge[] = [];
  cidadesSelecionadas: number[] = [];

  filtroNome: Filtro = { Propriedade: 'cidade', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  selectedFile: File;

  campoOrdenacao = 'uf, cidade';
  ordenarDesc = false;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  qlEditorModules = {
    counter: { unit: 'char', maxLength: 1000 },
  };

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image']
    ]
  };

  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private fornecedorService: FornecedorService,
    private router: Router,
    private carregandoService: CarregandoService,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private tagService: TagGiService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPremissaCentroDeDistribuicao();
    this.buscarPremissaMultiFornecedores();
    this.buscarPremissasSistema();

    if (this.route.snapshot.paramMap.get('id')) {
      this.idFornecedor = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarFornecedor();
      this.buscarCidades();
    } else {
      this.atualizaDadosFornecedor();
      this.fornecedor = new Fornecedor();
    }
  }

  buscarFornecedor() {
    this.carregandoService.mostra('buscaFornecedor');

    this.fornecedorService
      .consultarPorIdFornecedor(this.idFornecedor)
      .subscribe(
        (fornecedor) => {
          this.fornecedor = fornecedor;
          this.atualizaDadosFornecedor();
        },
        (erro) => {
          this.carregandoService.esconde('buscaFornecedor');
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.pCentroDistribuicao = f.valor;
        this.titulo = this.pCentroDistribuicao
          ? 'Cadastro de Centro de Distribuição'
          : 'Cadastro de Fornecedor';

        if (this.pCentroDistribuicao) {
          this.buscarTags();
        }

        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaMultiFornecedores() {
    this.carregandoService.mostra('buscarPremissaMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;
        this.carregandoService.esconde('buscarPremissaMultiFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaMultiFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissas = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosFornecedor() {
    this.carregandoService.esconde('buscaFornecedor');
    this.carregando = false;
  }

  salvar() {
    this.carregandoService.mostra('salvaFornecedor');

    if (
      this.fornecedor.margemDistribuidor !== undefined &&
      this.fornecedor.margemDistribuidor !== null
    ) {
      this.fornecedor.margemDistribuidor = Number(
        this.fornecedor.margemDistribuidor
      );
    }

    if (
      this.fornecedor.sigla !== null &&
      this.fornecedor.sigla !== undefined &&
      this.fornecedor.sigla.length > 0
    ) {
      this.fornecedor.sigla = this.fornecedor.sigla.toUpperCase();
    }

    this.fornecedorService.salvar(this.fornecedor).subscribe(
      () => {
        this.notificacaoService.sucesso(
          `${this.pCentroDistribuicao ? 'Centro de Distribuição' : 'Fornecedor'
          } salvo com sucesso!!!`
        );

        this.router
          .navigate([
            `${this.pCentroDistribuicao
              ? '/configuracoes/centros-de-distribuicao'
              : '/configuracoes/fornecedores'
            }`,
          ])
          .then(() => {
            this.carregandoService.esconde('salvaFornecedor');
          });
      },
      (erro) => {
        this.carregandoService.esconde('salvaFornecedor');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(0).subscribe(
      (tags) => {
        this.tags = tags;
        this.tags.forEach((p) => (p.disabled = p.somenteApi));

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFiltroCidades(uf: string) {
    if (uf === null || uf === undefined) {
      this.cidadesFiltro = [];
      return;
    }

    this.carregandoService.mostra('buscaFiltroCidades');
    this.ibgeService.consultarPorEstado(uf.toUpperCase()).subscribe(data => {
      this.cidadesFiltro = data;
      this.carregandoService.esconde('buscaFiltroCidades');
    }, () => {
      this.notificacaoService.erro('Não foi possível buscar as cidades do estado selecionado!');
      this.carregandoService.esconde('buscaFiltroCidades');
    });
  }

  buscarCidades() {
    this.carregandoService.mostra('buscaCidades');
    this.carregando = true;

    const estado = this.estadoSelecionado
      ? this.estadoSelecionado.toUpperCase()
      : null;

    this.ibgeService
      .consultarCidadesComPaginacao(
        this.filtroNome.Valor,
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? 'desc' : 'asc',
        this.idFornecedor,
        estado
      )
      .subscribe(
        (data: any) => {
          this.cidades = data.itens;
          this.listaDeItensPorPagina =
            this.utilitarioService.calculaItensPorPagina(data.total);

          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = data.total;

          this.carregando = false;
          this.carregandoService.esconde('buscaCidades');
        },
        (erro) => {
          this.carregandoService.esconde('buscaCidades');
          this.notificacaoService.erro(erro);
        }
      );
  }

  exportar() {
    this.carregandoService.mostra('exportaCidades');
    this.ibgeService
      .exportar(
        this.filtroNome.Valor,
        this.estadoSelecionado,
        null
      )
      .subscribe(
        (arq: Blob) => {
          const nomeArquivo =
            'Cidades_CD_' + this.fornecedor.descricao + '.xlsx';

          this.utilitarioService.saveBlob(arq, nomeArquivo);
          this.carregandoService.esconde('exportaCidades');
        },
        (erro) => {
          this.carregandoService.esconde('exportaCidades');
          this.notificacaoService.erro(erro.error);
        }
      );
  }

  importar() {
    const dados = new FormData();

    if (!this.selectedFile) {
      this.notificacaoService.aviso('Selecione um arquivo para importar!');
      return;
    }

    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.ibgeService.importar(dados).subscribe(() => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso('Dados importados com sucesso!!!');
      this.excluirArquivo();
      this.buscarCidades();
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarCidades();
  }

  filtra() {
    this.buscarCidades();
    this.paginator.firstPage();
  }

  filtraAvancado() {
    this.buscarCidades();
    this.paginator.firstPage();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.cidades = this.cidades.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'cidade':
            return this.compare(a.cidade, b.cidade, isAsc);
          default:
            return 0;
        }
      });

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
